import React, {
    forwardRef
} from 'react';
import PropTypes from 'prop-types';

const RIQButton = forwardRef(function RIQButton(props, ref) {
    const {className, disabled, onClick, variant = 'default', children} = props;

    let variantClasses;
    switch (variant) {

        case 'primary':
            variantClasses = 'tlw-rounded-sm disabled_tlw-bg-blue-400 tlw-bg-blue-400 tlw-border-blue-500 disabled_tlw-border-blue-100 focus_tlw-border-blue-500 focus_tlw-bg-blue-300 hover_tlw-bg-blue-300 hover_tlw-border-blue-500 tlw-text-white tlw-text-md';
            break;

        case 'search':
            variantClasses = 'tlw-rounded-r-sm disabled_tlw-bg-blue-400 tlw-bg-blue-400 tlw-border-blue-500 focus_tlw-border-blue-500 focus_tlw-bg-blue-300 tlw-text-white';
            break;

        case 'default':
            variantClasses = 'tlw-rounded-sm hover_tlw-bg-gray-100 focus_tlw-bg-gray-100 active_tlw-bg-gray-200 disabled_tlw-border-gray-200 tlw-bg-white disabled_tlw-bg-gray-250 tlw-border-gray-600 tlw-text-gray-800 tlw-border-gray-600 hover_tlw-border-gray-600 focus_tlw-border-gray-600 active_tlw-border-gray-400 tlw-text-md';
            break;

        case 'danger':
            variantClasses = 'tlw-rounded-sm hover_tlw-bg-gray-100 focus_tlw-bg-gray-100 active_tlw-bg-gray-200 disabled_tlw-border-gray-200 tlw-bg-white tlw-border-gray-600 tlw-text-red-400 tlw-border-gray-600 hover_tlw-border-gray-600 focus_tlw-border-gray-600 active_tlw-border-gray-400';
            break;

        case 'link':
            variantClasses = 'tlw-border-0 tlw-bg-inherit tlw-text-blue-400 !tlw-shadow-none hover_tlw-text-blue-500 focus_tlw-text-blue-500 active_tlw-text-blue-500';
            break;

        case 'select-left':
            variantClasses = 'tlw-rounded-l-sm';
            break;

        case 'select-right':
            variantClasses = 'tlw-rounded-r-sm';
            break;

        default:
            throw new Error(`Unknown button variant: ${variant}`);
    }

    return (
        <button
            id={props.id}
            className={`tlw-border tlw-border-solid tlw-text-center tlw-shadow-sm disabled_tlw-pointer-events-none disabled_tlw-cursor-not-allowed disabled_tlw-opacity-65 ${variantClasses} ${className} disabled_tlw-shadow-none`}
            disabled={disabled}
            onClick={onClick}
            ref={ref}>
            {children}
        </button>
    );
});

RIQButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    variant: PropTypes.oneOf(['primary', 'search', 'default', 'danger', 'link', 'select-left', 'select-right'])
};

export default RIQButton;
